import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BrandSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[70%]">
          <span className="inline-block text-xs font-medium text-accent-400 tracking-wider mb-6">
            {t('home:brand.tag')}
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-foreground-950 leading-tight mb-12">
            {t('home:brand.heading')}
          </h2>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-3.5 rounded-full text-sm font-medium cursor-pointer transition-colors"
            >
              {t('home:brand.learnMore')}
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap border border-accent-500/30 text-accent-500 hover:bg-accent-500 hover:text-background-50 px-8 py-3.5 rounded-full text-sm font-medium cursor-pointer transition-all duration-300"
            >
              {t('home:brand.joinUs')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}